import { useMutation, useQuery } from '@tanstack/react-query';
import { webgwjsInstance } from '../redux/request/request';
import { getAccessToken } from "../helpers/authHelper";

type CheckEmailResponse = Partial<{
  accountId: number
  upnEmail: string
  accountEnabled: boolean
  authMode: string
  superPlusAdmin: boolean
  authenticationPath: string
  redirectUrl: string
}>;

type CheckEmailVariables = {
  upnEmail: string
};

const useCheckEmail = (options = {}) => useMutation({
  mutationFn: async ({ upnEmail }: CheckEmailVariables) => {
    console.log(upnEmail)
    const response = await webgwjsInstance.post<CheckEmailResponse>(
      '/api/v1/user/login/email-pre-check',
      { upnEmail },
    );

    return response.data;
  },
  ...options,
});

export type PermissionData = {
  roleCode?: string
  sections?: {
    section?: string
    functions?: {
      function?: string,
      permissionCode?: string,
    }[]
  }[]
}

type PermissionsResponse = {
  data?: PermissionData
}

const usePermissions = (options = {}) => useQuery({
  queryKey: ['permissions'],
  queryFn: async () => {
    const response = await webgwjsInstance.get<PermissionsResponse>(
      '/api/v1/cms/me/permissions',
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    // return {
    //   data: {
    //     ...response.data.data ?? {},
    //     sections: response.data.data?.sections?.map(section => { 
    //       return {
    //         ...section,
    //         functions: [
    //           ...(section.functions ?? []),
    //           ...[
    //             { section: "MEMBER", function: "ASSIGN_TAG" },
    //             { section: "SINO_CLUB", function: "VIEW_MEMBER_DETAILS" },
    //           ].map(permission => {
    //             return {
    //               ...permission,
    //               permissionCode: `${permission.section}.${permission.function}`
    //             }
    //           }).filter(permission => permission.section===section.section),
    //         ].filter(
    //           permission => permission.permissionCode && ![
    //             "ESTATE.EDIT",
    //           ].includes(permission.permissionCode)
    //         ),
    //       }
    //     }),
    //   }
    // }
    return response.data;
  },
  ...options,
});

export { useCheckEmail, usePermissions };
